<template>
  <el-dialog append-to-body :show-close="false" :visible="value" width="350px">
    <div slot="title" class="logout-tip-title">
      <i class="el-icon-warning" style="color: #4292ff; font-size: 20px; margin-right: 10px"></i>
      <span>下线提示</span>
    </div>
    <p class="logout-tip-content" style="margin: 0 0 0 30px">{{ tips }}</p>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="close" style="background: #4292ff"
        >我知道了</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: () => false
      }
    },
    data() {
      return {}
    },
    computed: {
      tips() {
        if (this.$store.state.user.logoutType === 2) {
          return '你的账号已在其它设备登录'
        }
        if (this.$store.state.user.logoutType === 4) {
          return '已在云滴管家上操作此设备退出登录'
        }
        return '此设备登录已过期'
      }
    },
    methods: {
      close() {
        if (this.$route.path !== '/login') {
          window.location.reload()
          return
        }
        this.$emit('input', false)
      }
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-dialog {
    border-radius: 8px;
  }
  ::v-deep .el-dialog__body {
    padding: 5px 20px;
  }
  .logout-tip-title {
    display: flex;
    align-items: center;
    color: #303133;
    font-size: 16px;
    font-weight: 500;
  }
  .logout-tip-content {
    font-size: 14px;
    color: #606266;
  }
</style>
